import { EventsManager } from '@game-libs/events-manager';
import { GameMenuCreator } from '..';
import { GameInputsMediator } from '@game-libs/inputs-mediator';
import { InputActions } from '@game-libs/models';
import { MouseEvent, useEffect, useRef } from 'react';

const { inputEvents } = GameInputsMediator();

export const ActionButton = ({
  children,
  action,
}: {
  children: string;
  action?: { type: string; payload?: unknown };
}) => {
  const { emit } = EventsManager();
  const emitEvent = () => {
    if (action) {
      emit(action.type, action?.payload);
    }
  };

  return <button onClick={emitEvent}>{children}</button>;
};

export const BackButton = ({ children }: { children?: string }) => {
  const { backToPrevious } = GameMenuCreator();
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const unbind = inputEvents.on(InputActions.BACK, () => buttonRef.current?.click());

    return unbind;
  }, []);

  return (
    <button ref={buttonRef} onClick={backToPrevious}>
      {children || 'Back'}
    </button>
  );
};

export const CloseButton = ({ children, onClick: onClickProp }: { children?: string; onClick?: () => void }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { closeMenu } = GameMenuCreator();

  useEffect(() => {
    const unbind = inputEvents.on(InputActions.CANCEL, () => buttonRef.current?.click());

    return unbind;
  }, []);

  const click = (e: MouseEvent<HTMLButtonElement>) => {
    onClickProp?.();
    closeMenu();
    e.preventDefault();
  };

  return (
    <button className={'button'} ref={buttonRef} onClick={click}>
      {children || 'Close'}
    </button>
  );
};

export const GoToButton = ({ children, nextMenu }: { children: string; nextMenu: string }) => {
  const { openMenu } = GameMenuCreator();
  const openNextMenu = () => {
    openMenu(nextMenu);
  };

  return <button onClick={openNextMenu}>{children}</button>;
};
